// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__ZT0An","left":"StickyBox_left__2BFL2","right":"StickyBox_right__3GZRz"};